export default __webpack_public_path__ + "static/media/dollhouse.8d835321.png";